import { Grid, styled } from "@mui/material";

export const CardRow = styled(Grid)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(7),
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: theme.spacing(1),
    },
}));
